import React from 'react';
export function HistorySection() {
  return <section data-id="element-4237">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-4238">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-4239">
          History of High-Speed Machining
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-4240">
        <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-4241">
          <div className="text-gray-700 text-lg leading-relaxed space-y-4" data-id="element-4242">
            <p data-id="element-4243">
              The first attempts at high speed machining occurred in the early
              1920's. About 10 years later Carl Solomon proposed his definition
              of high-speed machining: "At a certain cutting speed which is five
              to ten times higher than in conventional machining, the chip
              removal temperature at the cutting edge will start to decrease."
              His now famous graph included to the right has become synonymous
              with learning about high-speed machining and illustrates what has
              been coined as the 'Solomon Curve'.
            </p>
            <p data-id="element-4244">
              It wasn't until the late fifties when research into HSM began to
              take off. In the eighties Lockheed was an early adopter of HSM,
              they were then followed by others in aerospace manufacturing. It
              was at this point that high-speed machining became a feasible
              opposition to conventional machining.
            </p>
            <p data-id="element-4245">
              Today, high-speed machining is gaining popularity, and it is
              becoming more and more common to see it being implemented in
              machine shops. The reason for the slow adoption can be attributed
              to a couple of factors.
            </p>
            <p data-id="element-4246">
              The industry itself was cautious to the concept of high-speed
              machining, but what was arguably the largest factor was the state
              of manufacturing facilities. Many production facilities lacked the
              corresponding technology needed to successfully implement
              high-speed machining techniques. This is less common today as CNC
              Machines and CAM systems are designed with high speed machining in
              mind.
            </p>
          </div>
          <div className="text-center space-y-6" data-id="element-4247">
            <h3 className="text-2xl font-bold text-navy" data-id="element-4248">
              Solomon Curve - High Speed Machining
            </h3>
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/Milling%202019/Solomon%20Curve%20-%20High%20speed%20Machining.jpg" alt="Solomon Curve" className="w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-4249" />
          </div>
        </div>
      </div>
    </section>;
}